import React from 'react';
import { connect } from 'react-redux';
import { Auth } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
import { Route, Switch } from 'react-router-dom';
import { Config } from '@leverege/plugin';
import { History } from '@leverege/molten-core';
import { LoginRoutesAuthenticated } from '@leverege/api-ui-login';
import LoginScreen from "./login/LoginScreen.js";
import TemporaryUserLoginScreen from "./login/temporaryUser/TemporaryUserLoginScreen.js";
import MainScreen from "./main/MainScreen.js";
import InactivityScreen from "./support/InactivityScreen.js";
import InactivityTimer from "./support/InactivityTimer.js";
import ForbiddenScreen from "./support/ForbiddenScreen.js";
import MaintenanceReminders from "../views/maintenance/MaintenanceReminders.js";
import MaintenanceScreen from "./support/MaintenanceScreen.js";
import Head from "./support/Head.js";
import ReleaseAvailableOverlay from "../views/release/ReleaseAvailableOverlay.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class Logout extends React.Component {
  componentDidMount() {
    GlobalState.dispatch(Auth.logout());
  }
  render() {
    return null;
  }
}
class AuthCheckScreen extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: this.isMobile()
    };
  }
  onResize = () => {
    const {
      isMobile
    } = this.state;
    if (isMobile !== this.isMobile()) {
      this.setState({
        isMobile: this.isMobile()
      });
    }
  };
  componentDidUpdate(prevProps) {
    const {
      router,
      dispatch,
      molten,
      isLoggedIn
    } = this.props;
    const {
      location: {
        pathname
      }
    } = router;
    const {
      router: pRouter,
      isLoggedIn: pLoggedIn
    } = prevProps;
    const {
      location: {
        pathname: pPathName
      }
    } = pRouter;
    const inactive = History.adjustPath('/inactive');
    if (pPathName === inactive && pathname !== inactive) {
      this.inactivityTimer.init();
    }
    const pName = router?.location?.pathname;
    let redirect = isLoggedIn && (pName === History.adjustPath('/login') || pName === History.adjustPath('/temporaryUserLogin'));
    if (!redirect && isLoggedIn && !pLoggedIn) {
      const baseUrl = molten.getConfig('baseUrl');
      if (baseUrl != null && !pName.startsWith(baseUrl)) {
        redirect = true;
      }
    }
    if (redirect) {
      // Note, if we want to go to the initial url, we need to clear
      // the local storage variable that holds the last url
      dispatch(History.push(History.adjustPath('/')));
    }
  }
  componentDidMount() {
    const {
      router: {
        location: {
          pathname
        }
      }
    } = this.props;
    this.inactivityTimer = new InactivityTimer();
    if (pathname !== History.adjustPath('/inactive')) {
      this.inactivityTimer.init();
    }
    window.addEventListener('resize', this.onResize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }
  isMobile() {
    const wWidth = window.innerWidth;
    return wWidth < 1024;
  }
  getLoginOpts() {
    const loginOpts = Config.get('LoginScreen', 'loginOpts');
    const requestDeviceCodeOpts = Config.get('LoginScreen', 'requestDeviceCodeOpts');
    return {
      loginOpts,
      requestDeviceCodeOpts,
      adjustPath: History.adjustPath
    };
  }
  render() {
    const {
      isMobile
    } = this.state;
    const {
      auth,
      router,
      molten,
      isLoggedIn
    } = this.props;
    const appKey = isMobile ? 'molten/mobileAppClass' : 'molten/appClass';
    const maintenance = molten.getConfig('molten/maintenanceClass') || MaintenanceScreen;
    if (Auth.isVerifying(auth)) {
      return null;
    }
    if (!isLoggedIn) {
      const login = molten.getConfig('molten/loginClass') || LoginScreen;
      const forbidden = molten.getConfig('molten/forbiddenClass') || ForbiddenScreen;
      const temporaryUserLogin = molten.getConfig('molten/temporaryUserLoginClass') || TemporaryUserLoginScreen;
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [!router.location.pathname.startsWith('/maintenance') && /*#__PURE__*/_jsx(MaintenanceReminders, {}), /*#__PURE__*/_jsx(Head, {}), /*#__PURE__*/_jsxs(Switch, {
          location: router.location,
          children: [/*#__PURE__*/_jsx(Route, {
            exact: true,
            path: History.adjustPath('/forbidden'),
            component: forbidden
          }), /*#__PURE__*/_jsx(Route, {
            exact: true,
            path: History.adjustPath('/maintenance'),
            component: maintenance
          }), /*#__PURE__*/_jsx(Route, {
            exact: true,
            path: History.adjustPath('/temporaryUserLogin'),
            component: temporaryUserLogin
          }), /*#__PURE__*/_jsx(Route, {
            component: login
          })]
        })]
      });
    }
    // Get the base application class
    const App = molten.get(appKey) ||
    // set by initializer?
    molten.getConfig(appKey) ||
    // set by config?
    MainScreen // Not set at all
    ;
    return /*#__PURE__*/_jsxs(React.Fragment, {
      children: [!router.location.pathname.startsWith('/maintenance') && /*#__PURE__*/_jsx(MaintenanceReminders, {}), /*#__PURE__*/_jsx(ReleaseAvailableOverlay, {}), /*#__PURE__*/_jsx(Head, {}), /*#__PURE__*/_jsx(LoginRoutesAuthenticated, {
        afterRoutes: [/*#__PURE__*/_jsx(Route, {
          exact: true,
          path: History.adjustPath('/inactive'),
          component: InactivityScreen,
          props: molten.getProps()
        }, "inactive"), /*#__PURE__*/_jsx(Route, {
          path: History.adjustPath('/activateAccount'),
          component: Logout
        }, "activateAccount"), /*#__PURE__*/_jsx(Route, {
          exact: true,
          path: History.adjustPath('/maintenance'),
          component: maintenance
        }, "maintenance"), /*#__PURE__*/_jsx(Route, {
          path: "/",
          component: App,
          props: molten.getProps()
        }, "root")],
        ...this.getLoginOpts()
      })]
    });
  }
}
export default connect(state => ({
  auth: state.auth,
  router: state.router,
  isLoggedIn: Auth.isLoggedIn(state.auth)
}))(AuthCheckScreen);